// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-chat-container {
  display: none !important;
  position: fixed;
  bottom: 100px;
  right: 24px;
  z-index: 1000;
  pointer-events: none;
}

.quick-chat-container > * {
  pointer-events: auto;
}

/* Trigger Button */
.quick-chat-trigger {
  display: none !important;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #FF3D00, #FF9100);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 24px rgba(255, 61, 0, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.quick-chat-trigger:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 12px 30px rgba(255, 61, 0, 0.5);
  background: linear-gradient(135deg, #FF4D00, #FFA100);
}

.quick-chat-trigger.active {
  transform: rotate(135deg) scale(0.9);
  background: #2D2D2D;
  border-color: rgba(255,255,255,0.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.trigger-icon {
  font-size: 26px;
}

/* Menu */
.quick-chat-menu {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 280px;
  background: rgba(18, 18, 20, 0.85);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  transform-origin: bottom right;
}

.quick-chat-sections {
  padding: 20px;
}

.section-title {
  font-size: 11px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  margin-bottom: 14px;
  letter-spacing: 1.2px;
}

.emotes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.emote-btn {
  font-size: 26px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.emote-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-3px) scale(1.1);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.quick-chat-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 18px 0;
}

.phrases-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.phrase-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  padding: 10px 16px;
  color: rgba(255, 255, 255, 0.9);
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s;
}

.phrase-btn:hover {
  background: linear-gradient(90deg, rgba(255,61,0,0.2), rgba(255,145,0,0.1));
  border-color: rgba(255, 61, 0, 0.3);
  transform: translateX(6px);
  color: #fff;
}

/* Incoming Bubble */
.quick-chat-bubble-mount {
  position: absolute;
  bottom: 140px;
  right: 0;
  min-width: 140px;
  pointer-events: none;
}

.quick-chat-bubble {
  background: #fff;
  color: #121214;
  padding: 12px 20px;
  border-radius: 20px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  font-weight: 700;
  width: fit-content;
  float: right;
  white-space: nowrap;
  animation: bubblePop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes bubblePop {
  0% { transform: scale(0.5) translateY(20px); opacity: 0; }
  100% { transform: scale(1) translateY(0); opacity: 1; }
}

/* Base Animations */
.animate-slide-up {
  animation: slideUp 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes slideUp {
  0% { transform: translateY(15px) scale(0.95); opacity: 0; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .quick-chat-container {
    bottom: 80px;
    right: 16px;
  }
  
  .quick-chat-trigger {
    width: 48px;
    height: 48px;
  }
  
  .quick-chat-menu {
    width: 250px;
    bottom: 60px;
  }
  
  .emote-btn {
    font-size: 22px;
    padding: 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/QuickChat.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,0CAA0C;EAC1C,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2EAA2E;EAC3E,mCAAmC;EACnC,0BAA0B;EAC1B,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,KAAK,sCAAsC,EAAE,UAAU,EAAE;EACzD,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;;AAEA,oBAAoB;AACpB;EACE,8DAA8D;AAChE;;AAEA;EACE,KAAK,uCAAuC,EAAE,UAAU,EAAE;EAC1D,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".quick-chat-container {\n  display: none !important;\n  position: fixed;\n  bottom: 100px;\n  right: 24px;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.quick-chat-container > * {\n  pointer-events: auto;\n}\n\n/* Trigger Button */\n.quick-chat-trigger {\n  display: none !important;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #FF3D00, #FF9100);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  box-shadow: 0 8px 24px rgba(255, 61, 0, 0.3);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.quick-chat-trigger:hover {\n  transform: translateY(-4px) scale(1.05);\n  box-shadow: 0 12px 30px rgba(255, 61, 0, 0.5);\n  background: linear-gradient(135deg, #FF4D00, #FFA100);\n}\n\n.quick-chat-trigger.active {\n  transform: rotate(135deg) scale(0.9);\n  background: #2D2D2D;\n  border-color: rgba(255,255,255,0.1);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n}\n\n.trigger-icon {\n  font-size: 26px;\n}\n\n/* Menu */\n.quick-chat-menu {\n  position: absolute;\n  bottom: 80px;\n  right: 0;\n  width: 280px;\n  background: rgba(18, 18, 20, 0.85);\n  backdrop-filter: blur(20px) saturate(180%);\n  -webkit-backdrop-filter: blur(20px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);\n  overflow: hidden;\n  transform-origin: bottom right;\n}\n\n.quick-chat-sections {\n  padding: 20px;\n}\n\n.section-title {\n  font-size: 11px;\n  font-weight: 800;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  margin-bottom: 14px;\n  letter-spacing: 1.2px;\n}\n\n.emotes-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n}\n\n.emote-btn {\n  font-size: 26px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 10px;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.emote-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n  transform: translateY(-3px) scale(1.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.2);\n}\n\n.quick-chat-divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n  margin: 18px 0;\n}\n\n.phrases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.phrase-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.03);\n  border-radius: 10px;\n  padding: 10px 16px;\n  color: rgba(255, 255, 255, 0.9);\n  text-align: left;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.25s;\n}\n\n.phrase-btn:hover {\n  background: linear-gradient(90deg, rgba(255,61,0,0.2), rgba(255,145,0,0.1));\n  border-color: rgba(255, 61, 0, 0.3);\n  transform: translateX(6px);\n  color: #fff;\n}\n\n/* Incoming Bubble */\n.quick-chat-bubble-mount {\n  position: absolute;\n  bottom: 140px;\n  right: 0;\n  min-width: 140px;\n  pointer-events: none;\n}\n\n.quick-chat-bubble {\n  background: #fff;\n  color: #121214;\n  padding: 12px 20px;\n  border-radius: 20px;\n  border-bottom-right-radius: 4px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  font-size: 16px;\n  font-weight: 700;\n  width: fit-content;\n  float: right;\n  white-space: nowrap;\n  animation: bubblePop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes bubblePop {\n  0% { transform: scale(0.5) translateY(20px); opacity: 0; }\n  100% { transform: scale(1) translateY(0); opacity: 1; }\n}\n\n/* Base Animations */\n.animate-slide-up {\n  animation: slideUp 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes slideUp {\n  0% { transform: translateY(15px) scale(0.95); opacity: 0; }\n  100% { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .quick-chat-container {\n    bottom: 80px;\n    right: 16px;\n  }\n  \n  .quick-chat-trigger {\n    width: 48px;\n    height: 48px;\n  }\n  \n  .quick-chat-menu {\n    width: 250px;\n    bottom: 60px;\n  }\n  \n  .emote-btn {\n    font-size: 22px;\n    padding: 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
